export function formatAccountDate(iso: string): string {
  if (!iso) return "";
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return iso.slice(0, 10);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso.slice(0, 10);
  }
}

export function formatAmountInr(amount: number | null): string {
  if (!amount) return "";
  return `Rs. ${amount.toLocaleString("en-IN")}`;
}
